<template>
    <div>
        <div class="heading-travel-policy">
            <span :class="carAverageDailyCostObj.isActive ? 'tag is-success' : 'tag'">Standard rule</span>
            <div class="right-content">
                <div class="lefttext">
                    <p class="paragrapgh">{{ title }}</p>
                    <p>Trigger when the daily cost is more than
                        <span class="rule-config-variable" @click="isEdit = !isEdit">{{
                            carAverageDailyCostObj.value
                                ? this.$options.filters.formatCurrency(carAverageDailyCostObj.value, 0, currencyCode)
                                : "N/A"
                        }}
                            <b-icon icon="pencil" size="is-small"></b-icon>
                        </span>
                    </p>
                </div>
                <div class="allbtns">
                    <b-switch :rounded="true" :value="carAverageDailyCostObj.isActive"
                        v-model="carAverageDailyCostObj.isActive" @input="carDailyCost" :left-label="true">{{
                            carAverageDailyCostObj.isActive ? 'Active' : 'Inactive' }}
                    </b-switch>
                </div>
            </div>
        </div>
        <div v-if="isEdit" class="edittravelpolicy">
            <CarDailyCost @carDailyCost="getValue" :carCost="carAverageDailyCostObj.value" />
            <p>Enter amount</p>
            <b-button @click="saveCall">SAVE</b-button>
        </div>
        <StandardRuleActions v-if="carAverageDailyCostObj.isActive && !isEdit" :ruleObj="carAverageDailyCostObj"
            :title="title" @save="updateActions" />
    </div>
</template>
<script>
import CarDailyCost from '../CommonRules/CarDailyCost.vue';
import StandardRuleActions from "../StandardRuleActions.vue";
export default {
    name: "CarAverageDailyCost",
    props: {
        value: {
            type: [Object],
        },
    },
    components: {
        CarDailyCost,
        StandardRuleActions
    },
    data() {
        return {
            carAverageDailyCostObj: this.value ? this.value : {
                name: "carDailyCost",
                isActive: false,
                value: 50,
                type: 'car',
                message: '',
            },
            isEdit: false,
            emitedValue: null,
            title: "Average daily cost"
        }
    },
    computed: {
        currencyCode() {
            return this.$store.getters['travellersAndTrips/getUserDefaultCurrency'];
        },
    },
    methods: {
        saveCall() {
            this.isEdit = false;
            if (this.emitedValue || this.emitedValue == '') {
                this.carAverageDailyCostObj.value = this.emitedValue;
            }
            this.buildMessage();
        },
        getValue(val) {
            this.emitedValue = val;
        },
        carDailyCost() {

            if (!this.carAverageDailyCostObj.isActive) {
                // Clear the custom action parameters when deactivating
                this.clearActionParams();
            } else {
                // Rebuild message when activating
                this.buildMessage();
            }

            this.emitRuleObj();
        },
        clearActionParams() {
            // Reset to default actions when rule is not active ()
            this.carAverageDailyCostObj.useCustomActions = false;
            delete this.carAverageDailyCostObj.visibility;
            delete this.carAverageDailyCostObj.approvalLevel;
            delete this.carAverageDailyCostObj.notifications;
        },
        updateActions(updatedRule) {
            // Merge the updated properties into carAverageDailyCostObj
            this.carAverageDailyCostObj = { ...this.carAverageDailyCostObj, ...updatedRule };

            // If useCustomActions is false, delete the associated properties
            if (!updatedRule.useCustomActions) {
                this.clearActionParams();
            }

            this.buildMessage();

            this.emitRuleObj();
        },
        emitRuleObj() {

            this.$emit('carDailyCost', this.carAverageDailyCostObj)
        },
        buildMessage() {
            var string = 'Trigger when the daily cost is more than ';
            const currencyName = this.$store.getters['travellersAndTrips/getUserCurrencyInfo'].name;
            this.carAverageDailyCostObj.message = string + (this.carAverageDailyCostObj.value ? this.$options.filters.formatCurrency(this.carAverageDailyCostObj.value, 0, this.currencyCode) : 'N/A');
        }
    },
    mounted() {
        this.carAverageDailyCostObj.type = 'car';

        this.emitRuleObj();

    },
    watch: {
        value: {
            handler(newVal, prevVal) {
                this.carAverageDailyCostObj = this.value;
                this.carAverageDailyCostObj.type = 'car';

                this.buildMessage();
                this.emitRuleObj();

            },
            deep: true,
        },
    },
}
</script>